











































































import {Component, Prop} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import ErrorMessageHandlerMixin from '@/misc/ErrorMessageHandler.mixins';
import {validationMixin} from 'vuelidate';
import {minLength, required} from 'vuelidate/lib/validators';
import {passwordCriteria} from "@/misc/PasswortCriterias";
import UserRepository from "@/api/repositories/UserRepository";
import {namespace} from "vuex-class";
import {AUTH_STORE_NAME, AuthStoreGetters} from "@/store/auth.store";
import User from "@/models/User.model";

const AuthStore = namespace(AUTH_STORE_NAME);

@Component({
  components: {},
  mixins: [validationMixin],
  validations: {
    oldPassword: {
      required
    },
    newPassword: {
      required,
      minLength: minLength(8)
    },
  }
})
export default class ChangePasswordComponent extends mixins(ErrorMessageHandlerMixin) {
  @AuthStore.Getter(AuthStoreGetters.CURRENT_USER)
  private currentUser!: User;

  @AuthStore.Getter(AuthStoreGetters.TOKEN)
  private token!: string;

  /**
   * criterias that needs to fullfilled in order to set the password
   * @private
   */
  private passwordCriteria = [...passwordCriteria];

  /**
   * Validate the password input regarding the password criteria an base criteria (e. g. required)
   * @param value
   */
  public validatePasswordInput(value: string) {
    // base criteria
    this.triggerValidation('newPassword');
    // special password criteria
    this.passwordCriteria.forEach((criterion) => criterion.fullfilled = criterion.regEx.test(value));
  }

  /**
   * Is component loaded in modal dialog?
   */
  @Prop({default: true})
  public isModal!: boolean;

  /**
   * old password input field value
   * @private
   */
  public oldPassword: string = '';

  /**
   * new password input field value
   * @private
   */
  public newPassword: string = '';

  /**
   * flag that indicates if the old password field should be hidden
   * @private
   */
  private hideOldPassword = true;

  /**
   * flag that indicats if the new password field should be hidden
   * @private
   */
  private hideNewPassword = true;

  /**
   * State Bool for a Valid form
   * @private
   */
  private isValid = true;

  /**
   * State Bool for a Loading Indicator
   * @private
   */
  private isLoading = false;

  /**
   * checks if every password criteria was checked
   * @private
   */
  private get criteriaChecked() {
    return this.passwordCriteria?.filter((c) => !c.fullfilled).length > 0;
  }

  /**
   * is called when the user clicks on the save button, validates the inputs and tries to change the password of the
   * user
   * @private
   */
  private async saveData() {
    // validates the form and checks if every input was made correctly
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.$notifyErrorSimplified('GENERAL.NOTIFICATIONS.REGISTRATION_WRONG_CREDENTIALS');
      return;
    }

    if(this.criteriaChecked) {
      this.$notifyErrorSimplified('GENERAL.NOTIFICATIONS.REGISTRATION_WRONG_CREDENTIALS');
      return;
    }

    try {
      // tries to change the password in the api
      this.isLoading = true;
      await UserRepository.changePassword(this.currentUser._id!, this.oldPassword!, this.newPassword!);

      // Show Success Message
      this.$notifySuccessSimplified('GENERAL.NOTIFICATIONS.PASSWORD_CHANGED_SUCCESS');
      this.dismiss(true);
    } catch (e) {
      this.$handleError(e, () => {
        switch(e.status) {
          case 409:
            this.$notifyErrorSimplified('GENERAL.NOTIFICATIONS.PASSWORD_CHANGED_WRONG_PASSWORD');
            break;
          case 422:
            this.$notifyErrorSimplified('GENERAL.NOTIFICATIONS.PASSWORD_CHANGED_SAME_NEW_PASSWORD');
            break;
          default:
            this.$notifyErrorSimplified('GENERAL.NOTIFICATIONS.PASSWORD_CHANGED_FAILURE');
        }
      });
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * is called when the dialog should be dismissed, calls close dialog action
   * @param reload
   * @private
   */
  private dismiss(reload: boolean = false) {
    this.oldPassword = '';
    this.newPassword = '';
    this.$v.$reset();
    this.$emit('closeDialog', reload);
  }
}
